export type IGetFieldIdentifierForId = (id: string | number, suffix?: string) => string;

export function getFieldIdentifierForId(id: string | number, suffix = ''): string {
  let identifier = '';
  for (const field of (window as any)[`fields${suffix}`]) {
    if (String(field.id) === String(id)) {
      identifier = field.identifier;
      break;
    }
  }
  return identifier;
}
